import { callZpayFunction } from '../../callZpayFunction';

// 주문내역 삭제
export const deleteOrder = (order_number: string) => {
  callZpayFunction('deleteOrder')({ order_number });
};
